import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGamOverviewWeb = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m24 28.8 2.45-5.35L31.8 21l-5.35-2.45L24 13.2l-2.45 5.35L16.2 21l5.35 2.45ZM7 36q-1.2 0-2.1-.9Q4 34.2 4 33V9q0-1.2.9-2.1Q5.8 6 7 6h34q1.2 0 2.1.9.9.9.9 2.1v24q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h34V9H7v24Zm-3.5 9q-.65 0-1.075-.425Q2 41.15 2 40.5q0-.65.425-1.075Q2.85 39 3.5 39h41q.65 0 1.075.425Q46 39.85 46 40.5q0 .65-.425 1.075Q45.15 42 44.5 42ZM7 33V9v24Z" })
});
export default SvgGamOverviewWeb;
